style= require('./player-sources.styl')

section.control-panel
  .panel
    .select-season
      if seasons
        ft-dropdown.dropdown(icon)
          header.dropdown-header(slot="header")
            if this.sport
              .dropdown-icon
                ft-icon(name=`sports--${this.sport}`)
            span.dropdown-text=(this.sport) || 'All sports'
          each s in activeSeasons
            .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
              if s
                .dropdown-icon
                  ft-icon(name=`sports--${s}`)
              span= s 
      sporty-seasons(
        season=season,
        sport= this.sport,
        (change:season)=this.changeSeason(e),
        blank="<select a season>"
      )
      ft-dropdown.dropdown(icon)
        - const label = ' <any team>'
        header.dropdown-header(slot="header")
          if this.team
            .dropdown-icon
              img(src= this.team.iconUrl)
          span.dropdown-text=( this.team &&  this.team.name) || label
        .dropdown-item(role='option', value=label, (click)=this.changeTeam(label), selected=!this.team)
          span= label
        each team in sortedTeams
          .dropdown-item(role='option', value=team.name, (click)=this.changeTeam(team),selected=this.team === team)
            .dropdown-icon
              img(src=team.iconUrl)
            span= team.name
              
    .send-fixtures
      ft-button(success,
        disabled=season?.$isSubmitting,
        (click)=this.send(season, 'fixtures')
      )='Send Fixtures'
      ft-button(success,
        disabled=season?.$isSubmitting,
        (click)=this.send(season, 'prices')
      )='Send Prices'
      ft-button(success, (click)=this.autoAssign())='Matching'           
    if downloadCsvPath
      a.download(href=downloadCsvPath)
        ft-icon(name=`ui--download`)
        span Download CSV
    .upload   
      ft-button(secondary, (click)=this.upload(), disabled=!this.$file)='Upload CSV'
      ft-form-control.choose-file(type="file", (change)=this.setFile(e.target))
      if season?.lastPlayersUpdate
        -var by = season?.lastMatchesUpdate?.by?.email
        -var at = season?.lastMatchesUpdate?.at
        .divider
        ft-icon.bell(name='ui--notification_solid')
        .last-update
          if by
            .by= `Last update ${by}`
          if at  
          .at= moment(at).format('lll')
      ft-button.confirm(primary, disabled=$isSubmitting, (click)=this.save())='Save'
section.tabs
  .space
  .btns
    each tab, index in ['All players', 'N/A players']
      ft-button.tab(
        primary,
        (click)=this.setTab(index),
        active=this.tab === index
      )=tab
  .desc-block
    .desc
      .status-red
      .title='Player with status N/A'  
    .desc
      .status-yellow
      .title='Overridden Players'
section.player-info
  .field.entries
    .title
      .counter
        .name='Existing players'
        .count.sourced= filteredPlayers.length
      ft-form-control.search(
        type='search',
        (input)=this.updateFilter(e),
        value=search,
        placeholder='Search')
    if filteredPlayers.length > 0
      each player, index in filteredPlayers
        .entry(data-player=player._id)
          header
            ft-clipboard.id
              span= player._id
              span.match-icon
                ft-icon(name=`ui--clipboard`)
          section(
            unchecked=this.overridedPlayer(player),
            overrided=this.disabledPrice(player))
            label='Player name'
            .value= player.formalName            
          section
            label='Player team'
            .value= player.teamName || 'N/A'
          section
            label='Position on field'
            .value.pos= player.pos
          section
            label='T-shirt number'
            .value= player.shirt             
          ft-button(success, (click)=this.openModal(player))='Override'
          each source in this.sources(player)
            sporty-card.source(
              class={dragged: source.$isDragged}
              obj-id=source._id
              obj-class="PlayerSource"
              header="_id"
              keys='["name", "team", "pos", "shirt", "uid", "source"]')
    else      
      .no-players
        ft-icon(name='ui--player')
        .text= 'No players to display'            
  .field.new-entries(scroll=showScroll)
    .title
      .counter
        .name='New players'
        .count.new= newPlayers.length
      if newPlayers.length > 0  
        ft-button.undo(danger, (click)=this.clear())='Undo'
    .submit((click)=this.openModal(-1))
      .plus= '+'
      .add= 'Add new player'
    each source in newPlayers
      sporty-card.source(
        class={dragged: source.$isDragged}
        obj-id=source._id
        obj-class="PlayerSource"
        header="_id"
        keys='["name", "team", "pos", "shirt", "uid", "source"]')
  .field.unassigned
    .title.multiline
      .counter
        .name='Unassigned players'
        .count.no-source= nonSources.length  
        ft-button(success, (click)=this.assignNew())='Auto-assign'
      .search
        select.selector((change)=this.source = e.target.value || null)
          option(value="") <All Sources>
          if season
            each source in seasonSources
              option(value=source._id)= source.source
        select.selector((change)=applyState({ gender: e.target.value }) || null)
          option(value="") <All Genders>
          each gnd in genders
            option(value=gnd)= gnd
        select.selector((change)=applyState({ country: e.target.value }) || null)
          option(value="") <All Countries>
          each cnt in countries
            option(value=cnt.alpha2)= cnt.name
    if nonSources.length > 0
      each source in nonSources
        if !source.firstName && !source.lastName
          sporty-card.source(
            class={dragged: source.$isDragged}
            obj-id=source._id
            obj-class="PlayerSource"
            header="_id"
            keys='["customName", "team", "pos", "shirt", "uid", "source"]')
        else
          sporty-card.source(
            class={dragged: source.$isDragged}
            obj-id=source._id
            obj-class="PlayerSource"
            header="_id"
            keys='["name", "team", "pos", "shirt", "uid", "source"]')
    else      
      .no-players
        ft-icon(name='ui--player')
        .text= 'No players to display'
